import { Validator } from '../public'

type Primitive = string | number | boolean | bigint | symbol | null | Date | undefined

/**
 * Internal type used to define the shape of a type.
 * Maps TypeScript types to their corresponding validator shapes.
 * 
 * @template T - The type to create a shape for
 * @internal
 */
export type ShapeFor<T> =
  T extends Primitive
    ? Validator
    : T extends Array<infer _U>
      ? Validator
      : T extends object
        ? {
            [K in keyof T]-?:
              undefined extends T[K]
                ? Validator | ShapeFor<NonNullable<T[K]>>
                : ShapeFor<T[K]>
          }
        : never

/**
 * Creates a shape definition for a type.
 * This is the main entry point for defining shapes in the library.
 * 
 * @template T - The type to create a shape for
 * @param shape - The shape definition that matches the type
 * @returns The shape definition
 */
export function defineShape<T>(shape: ShapeFor<T>): ShapeFor<T> {
  return shape
} 